import * as React from 'react';

import { StatsigProvider } from '@coursera-web/statsig';
import { compose } from 'recompose';

import Retracked from 'js/app/retracked';
import connectToStores from 'js/lib/connectToStores';

import DefaultHeader from 'bundles/composable-page-header-consumer/header-renderers/DefaultHeader';
import UniversalPageFeatures from 'bundles/composable-page-header/components/UniversalPageFeatures';
import PageFooter from 'bundles/page-footer/components/PageFooter';
import ApplicationStoreClass from 'bundles/ssr/stores/ApplicationStore';

import 'css!bundles/collections/styl/index';

type Props = {
  requestCountryCode?: string;
  csrfToken?: string;
  children?: JSX.Element;
};

const CollectionsApp = ({ children }: Props) => {
  return (
    <div className="rc-CollectionsApp">
      <UniversalPageFeatures />
      <DefaultHeader showMetaNav />
      {children}
      <PageFooter />
    </div>
  );
};

const CollectionsAppWithProvider = ({ children, ...props }: Props) => {
  return (
    <StatsigProvider>
      <CollectionsApp {...props}>{children}</CollectionsApp>
    </StatsigProvider>
  );
};
export default compose<{}, Props>(
  connectToStores<Props, Omit<Props, 'csrfToken' | 'requestCountryCode'>>(
    [ApplicationStoreClass],
    (ApplicationStore, props) => ({
      ...props,
      csrfToken: ApplicationStore.getState().csrfToken,
      requestCountryCode: ApplicationStore.getState().requestCountryCode,
    })
  ),
  Retracked.createTrackedContainer(() => {
    return {
      namespace: {
        page: 'collections_page',
        app: 'collections',
      },
    };
  })
)(CollectionsAppWithProvider);
